import React from 'react';
import './Button.css';

export default function Button({
    href,
    className = '',
    children,
    onClick,
    fullWidth = false,
    icon = undefined,
    ...props
}) {
    const combinedClassName = `btn-common ${fullWidth ? 'btn-common--full-width' : ''} ${className}`.trim();

    return (
        <a
            href={href || undefined}
            className={combinedClassName}
            onClick={onClick}
            {...props}
        >
            {children}
            {icon && (
                <span
                    className="btn-icon"
                    style={{
                        maskImage: `url(${icon})`,
                        WebkitMaskImage: `url(${icon})`
                    }}
                />
            )}
        </a>
    );
}
